import React from 'react';
import style from './style.module.css';

const Button = ({ children }) => <div className={style.card}>{children}</div>;

export default Button;
